import React from 'react';
import { motion } from 'framer-motion';
import { SunriseIcon, ZapIcon, ShieldIcon, UserIcon } from 'lucide-react';
const benefits = [{
  icon: SunriseIcon,
  title: 'Primer Paso Libre',
  hook: 'Despertate sin miedo.',
  text: 'La Fase 1 apaga la inflamación en 10 días con activaciones de 8 min descalzo en tu habitación. Dejás de empezar el día con dolor.'
}, {
  icon: ZapIcon,
  title: 'Volvé a Picar',
  hook: 'Jugá sin calcular.',
  text: 'La Fase 2 reconstruye la fuerza del arco plantar. Sin equipamiento. Solo tu pie y el piso. Volvés a picar, frenar y saltar como antes.'
}, {
  icon: ShieldIcon,
  title: 'Blindaje Permanente',
  hook: 'Que no vuelva nunca.',
  text: 'La Fase 3 convierte tu pie en un resorte que absorbe impacto. Dejás de vivir con miedo a la recaída.'
}, {
  icon: UserIcon,
  title: 'Autonomía Total',
  hook: 'Sin depender de nadie.',
  text: 'Todo se hace solo, en casa, sin turnos ni traslados. Tu recuperación no depende de la agenda del kinesiólogo.'
}];
export function BenefitsSection() {
  return <section className="py-6 md:py-10 px-4 bg-dark-card" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-black uppercase text-white text-center mb-4" data-id="element-16">
          Cuando tu pie vuelva a ser{' '}
          <span className="text-neon" data-id="element-17">una herramienta</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-18">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-dark border border-dark-border rounded-xl p-4 flex gap-3" data-id="element-19">
              <div className="w-10 h-10 rounded-lg bg-neon/10 border border-neon/20 flex items-center justify-center shrink-0" data-id="element-20">
                <b.icon className="w-5 h-5 text-neon" data-id="element-21" />
              </div>
              <div data-id="element-22">
                <h3 className="text-base font-black text-white uppercase" data-id="element-23">
                  {b.title}
                </h3>
                <p className="text-neon text-base font-semibold italic mb-1" data-id="element-24">
                  {b.hook}
                </p>
                <p className="text-white text-base md:text-lg leading-relaxed" data-id="element-25">
                  {b.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}